import React from 'react'
import { array, bool, func, number } from 'prop-types'
import { branch } from 'baobab-react/higher-order'

import { Modal, ModalBody } from 'components/qstrap'

import ArrowLeft from 'components/atoms/SVGIcons/ArrowLeft'
import CampusPerfectCard from 'components/organisms/CampusPerfectCard'
import Typography from 'components/atoms/Typography/Typography'

const SchoolsModal = ({
  isOpen,
  onModalClose,
  index,
  schools,
}) => (
  <Modal
    autoFocus={false}
    isOpen={isOpen}
    fade={false}
    toggle={onModalClose}
    className="schools-modal__dialog"
  >
    <ModalBody>
      <div className="schools-modal__navbar" onClick={onModalClose}>
        <ArrowLeft fill="#7D92A9" className="m-r-md"/>
        <Typography variant="body" component="p">
          Pilihan {index}
        </Typography>
      </div>
      <div className="schools-modal__wrapper">
        {
          schools.map((school, idx) => (
            <div key={school.id} className="schools-modal__card col-md-4 col-sm-6 col-xs-12">
              <CampusPerfectCard
                dataTestId={`rec-campus-card-${idx}`}
                description={school.description}
                logo={school.logo}
                thumbnail={school.img}
                href={`/directory/${school.slug}`}
                kind="schools"
                title={school.name}
                major={school.major}
                capacity={school.capacity}
                interest={school.previous_year_registrants}
                competitiveLevel={Math.round(school.competitive_rate * 100)}
                withFooter
                shortImage
                withFlag={school.competitive_rate}
                category={school.competitive_rate ? 'Negeri' : 'Swasta'}
              />
            </div>
          ))
        }
      </div>
    </ModalBody>
    <style jsx global>
      {`
        .modal {
          background-color: #fff;
        }
        .schools-modal {
          &__dialog {
            height: 100%;
            margin: 0;

            .modal-content {
              height: 100%;
              border: none !important;
              box-shadow: none !important;
            }
            .modal-body {
              padding: 0;
            }
          }
          &__wrapper {
            overflow: auto;
            position: relative;
            padding: 80px 16px 16px 16px;
          }
          &__card {
            margin: 6px 0;
          }
          &__navbar {
            padding: 16px;
            box-shadow: 0 1px 3px 0 #a3b4ca;
            font-weight: bold;
            display: flex;
            align-items: center;
            width: 100%;
            background-color: #fff;
            position: fixed;
            z-index: 2;
            top: 0;
          }
        }
      `}
    </style>
  </Modal>
)

SchoolsModal.propTypes = {
  isOpen: bool,
  onModalClose: func,
  index: number,
  schools: array,
}

export default SchoolsModal
